module.exports = __webpack_public_path__ + "media/images/wsfr-sidebar-ef74ca960362c80ab3c505dbc4802d2f.png";